var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-status-or-retry"},[_c('project-status',{attrs:{"item":_vm.item}}),(_vm.hasAction)?_c('project-scan-action-table-cell',{attrs:{"item":_vm.item,"column":_vm.column},on:{"displayError":function($event){return _vm.$emit('displayError', $event)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }